import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Button — renders <Link> when `to`, <a target=_blank> when `href`, else <button>.
 * variant: primary | outline | ghost | maroon | white | soft
 * size: sm | md | lg
 */
export default function Button({
  variant = 'primary',
  size = 'md',
  block = false,
  to,
  href,
  icon,
  iconPosition = 'right',
  className = '',
  children,
  type = 'button',
  ...rest
}) {
  const cls = ['btn', `btn--${variant}`, size !== 'md' && `btn--${size}`, block && 'btn--block', className]
    .filter(Boolean)
    .join(' ');
  const content = (
    <>
      {icon && iconPosition === 'left' && <span className="btn__icon">{icon}</span>}
      <span className="btn__label">{children}</span>
      {icon && iconPosition === 'right' && <span className="btn__icon">{icon}</span>}
    </>
  );
  if (to) return <Link to={to} className={cls} {...rest}>{content}</Link>;
  if (href) return <a href={href} className={cls} target="_blank" rel="noopener noreferrer" {...rest}>{content}</a>;
  return <button type={type} className={cls} {...rest}>{content}</button>;
}
